import { useEffect, useRef } from 'react';
import type { IUseTableResetTableMethodsReturn, IUseTableReturn } from '../../useTable';
import type { IUseQueryTableFetchReturn } from '../../useQueryTableFetch';

interface IUseTablePreserverActivePageValidatorProps {
  activePage: IUseTableReturn<object>['activePage'];
  perPage: IUseTableReturn<object>['perPage'];
  resetActivePage: IUseTableResetTableMethodsReturn['resetActivePage'];
  total: IUseQueryTableFetchReturn<any>['total'];
  // TODO: AFTER SUPPORT RELEASE: Remove '?'
  isFetchedAfterMount?: IUseQueryTableFetchReturn<any>['isFetchedAfterMount'];
}

const useTablePreserverActivePageValidator = (
  props: IUseTablePreserverActivePageValidatorProps,
) => {
  const {
    activePage, resetActivePage, perPage, total, isFetchedAfterMount,
  } = props;

  const isInitialized = useRef(false);

  useEffect(() => {
    if (isInitialized.current || !isFetchedAfterMount) {
      return;
    }
    isInitialized.current = true;
    if (activePage > Math.ceil(total / perPage)) {
      resetActivePage();
    }
  }, [activePage, resetActivePage, perPage, isFetchedAfterMount, total]);
};

export default useTablePreserverActivePageValidator;
